import "./Footer.css"

export default function Footer() {
  return (
    <footer className="container-fluid flex-column bg-light text-black text-center py-4">
      <hr className="border-primary border-3 w-75 mx-auto" />
      <p className="mb-0">Licence MIT</p>
      <p className="mb-0">Copyright © agengemb 2025</p>
    </footer>
  );
}
